import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const AmericanFlagIcon = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/america-flag.png" style={style} />
}
